// EmployeePFStatement

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { EMPLOYEE_PF_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const EmployeePFStatement = () => {

    const [employeePFStatementData, setEmployeePFStatementData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const EmployeePFStatementColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "UAN_No",
            Header: "UAN No",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "salary_days",
            Header: "Salary Days",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "PF_Wages",
            Header: "PF Wages",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "PF_Contirbutions",
            Header: "PF Contributions",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Employee PF Statements Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={EmployeePFStatementColumns}
                data={employeePFStatementData}
                setData={setEmployeePFStatementData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_PF_REPORTS}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </div >
    );
}

export default EmployeePFStatement;